'use client'

import styled from 'styled-components'

import theme from '@/src/config/theme'
import Button from '@/src/shared/ui/button'

export const Wrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 18px;
  height: 18px;
`

export const BurgerButtonBars = styled.i<{$dark?: boolean}>`
  display: block;
  position: relative;
  width: 18px;
  height: 2px;
  background-color: ${props => props.$dark && theme.colors.primary || 'black'};
  transition: 0.3s;

  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${props => props.$dark && '#fff' || 'black'};
    transition: 0.3s;
  }

  &:before {
    transform: translate(0, -6px);
  }

  &:after {
    transform: translate(0, 6px);
  }
`

export const BurgerBtn = styled.div`
  grid-area: burger;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background-color: transparent;
  color: inherit;
  cursor: pointer;
  transition: 0.3s ease;

  &:focus {
    outline: none;
  }

  &.open {
    ${BurgerButtonBars} {
      background-color: transparent;

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }
    }
  }
`

export const ButtonWrapped = styled(Button)`
  display: flex;
  gap: 8px;
  align-items: center;
`
